(function() {
	let module = {};

	/** Global init code for multisite instance */
	module.init = () => {

	};

	var docReady = (callback) => {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
			// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			// IE <= 8
			document.attachEvent('onreadystatechange', () => {
				if (document.readyState === 'complete') callback();
			});
		}
	};

	docReady(() => {
		module.init();
	});

	HBS.namespace('ASM.brand', module);
}());